import SectionHeading from "./SectionHeading";

const REASONS = [
  {
    icon: "ri-user-heart-line",
    title: "1:1 맞춤 관리",
    desc: "개인별 피부 진단을 통해 고객님에게 꼭 맞는 프로그램을 설계합니다.",
  },
  {
    icon: "ri-award-line",
    title: "전문 관리사",
    desc: "자격증과 풍부한 경험을 갖춘 전문 관리사가 세심하게 관리합니다.",
  },
  {
    icon: "ri-flask-line",
    title: "프리미엄 제품",
    desc: "검증된 프리미엄 스킨케어 제품만을 엄선하여 사용합니다.",
  },
  {
    icon: "ri-shield-check-line",
    title: "철저한 위생",
    desc: "1회용품 사용과 정기적인 소독으로 언제나 청결을 유지합니다.",
  },
  {
    icon: "ri-heart-pulse-line",
    title: "체계적 사후관리",
    desc: "관리 후에도 꼼꼼한 피드백과 홈케어 안내를 제공합니다.",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "편안한 상담",
    desc: "부담 없는 무료 상담으로 피부 고민을 함께 해결해드립니다.",
  },
];

export default function WhyUs() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24">
      <div className="max-w-6xl mx-auto flex flex-col gap-12">
        <SectionHeading
          eyebrow="Why Bianca"
          title="비앙카를 선택해야 하는 이유"
          description="단순한 피부관리가 아닌, 고객님의 피부를 진심으로 생각하는 관리로 신뢰를 드립니다."
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {REASONS.map((reason) => (
            <div
              key={reason.title}
              className="flex items-start gap-4 p-6 rounded-2xl bg-background-50 border border-background-200/70 transition-all hover:border-primary-200 hover:bg-primary-50/40 cursor-pointer"
            >
              <span className="w-12 h-12 rounded-xl bg-primary-500 flex items-center justify-center shrink-0">
                <i className={`${reason.icon} text-xl text-white`}></i>
              </span>
              <div className="flex flex-col gap-1.5">
                <h3 className="text-base font-semibold text-foreground-900">{reason.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{reason.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}